import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

const defaultState = {
  state: null,
};

const CategoryContext = createContext(defaultState);

const CategoryProvider = ({ children }) => {
  const [category, setCategory] = useState(null);

  return (
    <CategoryContext.Provider
      value={{
        category,
        setCategory,
      }}
    >
      {children}
    </CategoryContext.Provider>
  );
};

CategoryProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export { CategoryContext, CategoryProvider };
